import { CardDetails, getCardTypeFromCardDetails, MessageContext } from 'owa-actionable-message-v2';
import { MailboxInfo } from 'owa-client-ids';
import { trace } from 'owa-trace';
import { telemetryProvider } from 'owa-actionable-message-analytics';

const ADAPTIVE_CARD_LOG_LINK = 'CardLinkInteraction';

export default function logAdaptiveCardLinkInteraction(
    e: MouseEvent,
    mailboxInfo: MailboxInfo,
    cardDetails: CardDetails,
    messageContext?: MessageContext
): void {
    trace.info(
        '[logAdaptiveCardLinkInteraction] Log event captured for link interaction on an adaptive card'
    );

    const cardType = getCardTypeFromCardDetails(cardDetails);
    if (cardDetails.card && cardType) {
        telemetryProvider.logTelemetry({
            cardDetails: cardDetails,
            eventName: `${ADAPTIVE_CARD_LOG_LINK}_${cardType}`,
            messageContext: messageContext,
        });
    } else {
        trace.warn(
            '[ActionableMessageDebug] logAdaptiveCardLinkInteraction: Cannot log link interaction - message card context is undefined'
        );
    }
}
